import { NavLink } from 'react-router-dom'
import { MOBILE_TABS, MOBILE_TABS_V2, MOBILE_HOME_TAB } from './mobileNav'
import { IconMore } from './icons'
import { useMobileV2 } from '../../../lib/flags'

interface Props {
  onOpenMore: () => void
  moreActive: boolean
}

/** Barra inferior fixa: 4 atalhos + botão "Mais". Alvos touch ≥ 56px.
 *  Launcher v2 (flag bx:mobileV2): ganha a aba "Início" e ícones SVG; OFF = idêntica à de sempre. */
export default function MobileTabBar({ onOpenMore, moreActive }: Props) {
  const v2 = useMobileV2()
  const tabs = v2 ? [MOBILE_HOME_TAB, ...MOBILE_TABS_V2] : MOBILE_TABS

  return (
    <nav className="shrink-0 bg-[#0D1B2A] border-t border-white/10 pb-safe no-tap-highlight">
      <div className="flex items-stretch">
        {tabs.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] touch-action-manip transition-colors ${
                isActive && !moreActive
                  ? 'text-brand-500'
                  : 'text-slate-400 active:text-white'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {v2 && item.Icon ? (
                  <item.Icon className={`w-[22px] h-[22px] transition-transform ${isActive && !moreActive ? 'scale-110' : ''}`} />
                ) : (
                  <span className={`text-xl leading-none transition-transform ${isActive && !moreActive ? 'scale-125' : ''}`}>
                    {item.icon}
                  </span>
                )}
                <span className="text-[10px] font-medium leading-none">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}

        {/* Botão "Mais" */}
        <button
          onClick={onOpenMore}
          className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] touch-action-manip transition-colors ${
            moreActive ? 'text-brand-500' : 'text-slate-400 active:text-white'
          }`}
        >
          {v2 ? (
            <IconMore className="w-[22px] h-[22px]" />
          ) : (
            <span className="text-xl leading-none">⚙️</span>
          )}
          <span className="text-[10px] font-medium leading-none">Mais</span>
        </button>
      </div>
    </nav>
  )
}
